<template>
  <section
    id="page-header"
    class="mb-4"
  >
    <v-row align="center">
      <v-spacer />
      <v-col cols="auto">
        <portal-target
          name="headerFilters"
          slim
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>

export default {
  name: 'ViewPageHeader',
  props: {
    showTeamSelect: {
      type: Boolean,
      default: true
    },
    allTeams: {
      type: Boolean,
      default: false
    }
  }
}
</script>
